import { Vue } from "vue-property-decorator"
import { commonObjectState } from "~/state/object"
import { IObjectState } from "~/state/types"
import { NewRequester } from "~/core/Requester"
import ObjectHelper from "~/utils/ObjectHelper"

interface IAffiliateState {
  affiliateDetail: IObjectState<any>
}

export const prefix = "affiliate/affiliate"

export const state = (): IAffiliateState => ({
  affiliateDetail: commonObjectState(),
})
export const getters = {
  getDetail: (state: any) => (): any => {
    return state.affiliateDetail.data || {}
  },
}

export const mutations = {
  updateDetail: (state: IAffiliateState, data) => {
    Vue.set(state, "affiliateDetail", data)
  },
}

export const actions = {
  getDetail: async ({ commit, state }, data) => {
    const path = `updateDetail`
    try {
      commit(path, ObjectHelper.toLoadingStatus(state.affiliateDetail))
      const response = await NewRequester.get<any>(data.url, { ...data })
      commit(
        path,
        ObjectHelper.toObjSuccessStatus(state.affiliateDetail, response.data)
      )
    } catch (e: any) {
      commit(
        path,
        ObjectHelper.toErrorStatus(state.affiliateDetail, e.response?.data || e)
      )
    }
  },
}
